import { IColumnSection } from '@faire/web-api--source/indigofair/data/IColumnSection';
import { IFilterablePaginatedSection } from '@faire/web-api--source/indigofair/data/IFilterablePaginatedSection';
import { ILayoutSection } from '@faire/web-api--source/indigofair/data/ILayoutSection';
import { IRotatingSection } from '@faire/web-api--source/indigofair/data/IRotatingSection';
import { ISectionLoggingData } from '@faire/web-api--source/indigofair/data/ISectionLoggingData';
import { ISectionStyle } from '@faire/web-api--source/indigofair/data/ISectionStyle';

export namespace ISection {
  /**
   * Return an instance of ISection with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ISection>): ISection =>
    ({
      ...(partial ?? {}),
    }) as ISection;
}

/**
 * A section is a wrapper around the components and determines the area that the components will be rendered in.
 * Sections can also describe other interactions within the section outside of rendering components
 * For example, filtering content within a section
 * Sections can be considered a data boundary for a group of components
 */
export interface ISection {
  /**
   * A unique identifier for the generated section instance
   * @protobufOption (faire.common.diffIgnore) = ALWAYS
   */
  id: string | undefined;
  /**
   * Logging data relating the SD UI section and all children
   */
  logging_data: ISectionLoggingData | undefined;
  /**
   * A flag to indicate if this section should be included in UPLT/TTL measurement
   */
  is_required_for_interactivity: boolean | undefined;
  /**
   * Defines styles that apply to the entire section
   */
  style: ISectionStyle | undefined;
  /**
   * @deprecated
   */
  column_section: IColumnSection | undefined;
  filterable_paginated_section: IFilterablePaginatedSection | undefined;
  rotating_section: IRotatingSection | undefined;
  layout_section: ILayoutSection | undefined;
}
